import { useQuery } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { QUERY_KEYS } from "./querykeys";
import {
  AxiosResponseAndError,
  ResponseType,
} from "../types/axiosResponseType";
import ApiRequest from "../ApiRequest";

export type SettingsType = {
    appVersion:string
}

type SettingResponse = ResponseType<SettingsType>;


function useSettingsQuery() {
  return useQuery<
    AxiosResponseAndError<SettingResponse>["response"],
    AxiosResponseAndError<SettingResponse>["error"]
  >({
    queryKey: [QUERY_KEYS.setting],
    queryFn: async () => await ApiRequest.get(`${requestURLs.setting}`),
    enabled: true,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
}

export default useSettingsQuery;
